/*
 * Copyright (c) 2022. 42 bv (www.42.nl). All rights reserved.
 */
"use strict";

/**
 * @ngdoc function
 * @name diceApp.component:diceStatusBulkChange
 */
angular.module("diceApp").component("diceArchiveBulkChange", {
  bindings: {
    type: "<",
    evaluations: "<",
    onChange: "&",
    onCancel: "&"
  },
  templateUrl: "es6/evaluations/bulk/archive.bulk.change.html",
  controllerAs: "archiveBulkChangeController",
  controller: function (Evaluation, $uibModal, message) {
    const archiveBulkChangeController = this;

    archiveBulkChangeController.submit = function () {
      archive();
    };

    function archive() {
      archiveBulkChangeController.loading = true;
      Evaluation.bulkArchive({
        evaluationIds: _.map(archiveBulkChangeController.evaluations, "id")
      })
        .$promise.then((result) => {
          message.addInfoLabel("Message.BulkArchived");
          archiveBulkChangeController.onChange({ result });
        })
        .finally(() => {
          archiveBulkChangeController.loading = false;
        });
    }
  }
});
